var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExclamationMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 -3.05176e-05C10.8656 -2.32679e-05 14 3.1344 14 6.99997C13.9999 10.8655 10.8655 14 7 14C3.13446 14 5.05515e-05 10.8655 0 6.99997C0 3.1344 3.13443 -3.05176e-05 7 -3.05176e-05ZM7 8.99997C6.80381 9.00397 6.61686 9.08445 6.47949 9.22458C6.34211 9.36479 6.26562 9.55367 6.26562 9.74997C6.26566 9.94612 6.34228 10.1342 6.47949 10.2744C6.61687 10.4146 6.80374 10.496 7 10.5C7.19625 10.496 7.38313 10.4146 7.52051 10.2744C7.65771 10.1342 7.73434 9.94611 7.73438 9.74997C7.73438 9.55367 7.65789 9.36479 7.52051 9.22458C7.38314 9.08445 7.19619 9.00398 7 8.99997ZM6.625 3.49997C6.55625 3.49997 6.5 3.55622 6.5 3.62497V7.87497C6.50006 7.94367 6.55629 7.99997 6.625 7.99997H7.375C7.44371 7.99996 7.49994 7.94366 7.5 7.87497V3.62497C7.5 3.55623 7.44374 3.49998 7.375 3.49997H6.625Z",
    fill: "#FCB400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationMark);
export default __webpack_public_path__ + "static/media/exclamation-mark.5961d60fab194b47586ec8606617631e.svg";
export { ForwardRef as ReactComponent };